module.exports = __webpack_public_path__ + "static/img/icon8-7.80d65ed2.png";